module.exports = __webpack_public_path__ + "static/media/arrowRight.e19d4ccb.svg";